import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { VENDING_PACKAGE_VOLUME_BY_PRODUCT_LIST_CHART_DEFINITION } from './vending-package-volume-by-product-list-chart.definition';
import { VENDING_PACKAGE_VOLUME_BY_PRODUCT_LIST_CHART_MOCK_DATA } from './vending-package-volume-by-product-list-chart.mock';

export const VendingPackageVolumeByProductListChart = (props: ListChartProps) => <ListChart {...props} />;

VendingPackageVolumeByProductListChart.definition = VENDING_PACKAGE_VOLUME_BY_PRODUCT_LIST_CHART_DEFINITION;
VendingPackageVolumeByProductListChart.mockData = VENDING_PACKAGE_VOLUME_BY_PRODUCT_LIST_CHART_MOCK_DATA;
